'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiCheck2 = function (_React$Component) {
    _inherits(AiCheck2, _React$Component);

    function AiCheck2() {
        _classCallCheck(this, AiCheck2);

        return _possibleConstructorReturn(this, (AiCheck2.__proto__ || Object.getPrototypeOf(AiCheck2)).apply(this, arguments));
    }

    _createClass(AiCheck2, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M45.853,23.968C47.284,26.42,48,29.097,48,31.999c0,2.904-0.717,5.581-2.148,8.033s-3.372,4.39-5.821,5.821 C37.58,47.284,34.903,48,31.998,48c-2.901,0-5.578-0.717-8.03-2.148s-4.393-3.369-5.824-5.821S16,34.903,16,31.999 c0-2.901,0.714-5.578,2.145-8.03s3.372-4.393,5.824-5.824S29.097,16,31.998,16c2.904,0,5.581,0.714,8.033,2.145 C42.48,19.575,44.422,21.517,45.853,23.968z M42.75,28.624c0-0.389-0.128-0.708-0.377-0.957l-1.896-1.874 c-0.264-0.264-0.577-0.398-0.936-0.398c-0.362,0-0.674,0.134-0.939,0.398l-8.501,8.479l-4.706-4.709 c-0.264-0.264-0.577-0.395-0.939-0.395s-0.674,0.131-0.939,0.395l-1.896,1.874c-0.249,0.249-0.374,0.571-0.374,0.957 c0,0.377,0.125,0.69,0.374,0.939l7.544,7.54c0.261,0.264,0.574,0.398,0.936,0.398c0.377,0,0.696-0.134,0.96-0.398l11.311-11.311 C42.623,29.312,42.75,29,42.75,28.624z' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '16 16 32 32';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-check-2', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-check-2', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiCheck2;
}(_react2.default.Component);

exports.default = AiCheck2;